var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgAquamarineGemOutline = function SvgAquamarineGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.25 285.25L362.25 23.25L466.75 156.25L536.25 244.75L588.25 309.75L577.75 371.75L563.75 464.75L515.25 512.25L508.75 522.25L471.75 571.75L447.25 603.25L362.25 704.75L307.75 644.25L153.25 498.25L139.75 331.25L159.25 285.25Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgAquamarineGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/aquamarine-gem-outline.8b5ce61d7b39023473c075f59ea2bd89.svg";